import React, { useEffect, useState, useRef } from 'react';
import { EXPENSE_ADMIN_SEND_DELAY_MS } from '../../constants/expenseConstants';
import { getExpenseSendRemainingMs } from '../../services/expenseFirestore';
import './ExpensePendingToast.css';

export default function ExpensePendingToast({ expense, onCancel, onComplete, closeToast }) {
  const [remaining, setRemaining] = useState(() => getExpenseSendRemainingMs(expense));
  const completedRef = useRef(false);
  const onCompleteRef = useRef(onComplete);
  const closeToastRef = useRef(closeToast);
  const onCancelRef = useRef(onCancel);
  const expenseRef = useRef(expense);

  onCompleteRef.current = onComplete;
  closeToastRef.current = closeToast;
  onCancelRef.current = onCancel;
  expenseRef.current = expense;

  useEffect(() => {
    completedRef.current = false;

    const tick = () => {
      if (completedRef.current) return;

      const next = getExpenseSendRemainingMs(expenseRef.current);
      setRemaining((prev) => (prev === next ? prev : next));

      if (next <= 0) {
        completedRef.current = true;
        onCompleteRef.current?.();
        closeToastRef.current?.();
      }
    };

    tick();
    const timer = setInterval(tick, 250);
    return () => clearInterval(timer);
  }, [expense.id, expense.adminSendAt, expense.sentToAdmin, expense.sendPaused]);

  const progress = Math.min(100, ((EXPENSE_ADMIN_SEND_DELAY_MS - remaining) / EXPENSE_ADMIN_SEND_DELAY_MS) * 100);
  const secondsLeft = Math.ceil(remaining / 1000);

  const handleCancel = () => {
    if (completedRef.current) return;
    completedRef.current = true;
    closeToastRef.current?.();
    onCancelRef.current?.();
  };

  return (
    <div className="exp-pending-toast">
      <div className="exp-pending-toast-header">
        <div>
          <strong>Expense added to history</strong>
          <p>Sending to admin in {secondsLeft}s</p>
        </div>
        <button type="button" className="exp-pending-toast-close" onClick={handleCancel} title="Cancel and edit">
          <i className="fas fa-times" />
        </button>
      </div>
      <div className="exp-pending-toast-bar">
        <div className="exp-pending-toast-bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <p className="exp-pending-toast-hint">Click × to cancel and re-edit this expense</p>
    </div>
  );
}
